








import Vue from "vue";
import tours from "@/components/TeambotTours/tours";
import { getFeatureWalkthrough, updateFeatureWalkthrough } from "@/helpers/api";
import TourContainer from "@/components/TourContainer.vue";

interface State {
  featureWalkthrough: any;
}

export default Vue.extend({
  name: "TeambotTour",
  components: { TourContainer },
  props: {
    name: { type: String, required: true },
    isLoading: { type: Boolean, required: true },
    closeCount: { type: Number, required: true }
  },
  data(): State {
    return {
      featureWalkthrough: {}
    };
  },
  // async mounted() {
  //   this.initTours();
  // },
  methods: {
    async initTours(): Promise<void> {
      this.featureWalkthrough = await getFeatureWalkthrough(this.name);

      // If the walkthrough has been completed or closed more than threshold, don't show the walkthrough
      if (
        this.featureWalkthrough.closeCount > this.closeCount ||
        this.featureWalkthrough.completed
      ) {
        return;
      }

      // If the walkthrough is for the coachNav, start the tour
      if (this.name == "coachNav") {
        this.startTour();
        return;
      }

      // Validate the coachnav walkthrough is completed before starting the tour
      const navWalkthrough = await getFeatureWalkthrough("coachNav");
      if (navWalkthrough.completed) {
        this.startTour();
      }
    },
    startTour(): void {
      if (!this.isLoading) {
        // @ts-ignore
        this.$tours[this.name].start();
      } else {
        setTimeout(this.startTour, 2000);
      }
    },
    async updateFeatureWalkthrough(isCompleted: boolean): Promise<void> {
      console.log("updateFeatureWalkthrough", isCompleted);
      await updateFeatureWalkthrough(this.name, isCompleted);
    }
  },
  computed: {
    steps(): any {
      // @ts-ignore
      return tours[this.name].steps;
    },
    callbacks(): any {
      // @ts-ignore
      const callbacks = tours[this.name].callbacks;
      callbacks.onSkip = () => this.updateFeatureWalkthrough(false);
      callbacks.onExit = () => this.updateFeatureWalkthrough(false);
      callbacks.onFinish = () => this.updateFeatureWalkthrough(true);
      return callbacks;
    }
  }
});
